module.exports = __webpack_public_path__ + "img/corp-analytics-side.c54f9b9d.svg";